const Kategoriya3213 = () => {
    return (
        <div style={{ fontFamily: "Times New Roman", fontSize: "14pt" }} className="container mt-5">
    <h3 className="text-center text-primary">
        3-sinf 2-chorak<br />
        Mavzu: Gap bo'laklari<br />
        "Sal murakkab" bo'limidagi topshiriqlar va ularni o'tkazish metodikasi
    </h3>
    <b>1-mashq. Nuqtalar o'rniga so'roqqa javob bo'ladigan gap mazmuniga mos so'zni qo'ying.</b><br />
    <i>Ta'limiy maqsad:</i> O'quvchilarning gap bo'laklari haqidagi ko'nikmalarini rivojlantirish.<br />
    <i>Mashg'ulot davomiyligi:</i> 3-4 daqiqa<br />
    … (qachon?) so'ng dasturxonlar yig'ishtirilib, … (nima?) tomosha qildik.<br />
    Ertalabki … (nima?) sog'lik garovi bo'lib, barcha bu odatga rioya qilishi zarur.
    <p><b>2-mashq. Maqollarni mantiqan davom ettiring.</b></p>
    <p>Yaxshi topib …, yomon … .</p>
    <p>Yaxshi bilan … yetarsan murodga, … bilan yursang … uyatga.</p>
    <p><b>3-mashq. FDM usulidan foydalanib, berilgan matnni izohlang.</b></p>
    <p><i>Ta'limiy maqsad:</i> O'quvchilarning bog'lanishli nutq haqidagi ko'nikmalarini rivojlantirish.</p>
    <p><i>Mashg'ulot davomiyligi:</i> 3-4 daqiqa</p>
    <p>Yer va Quyosh o'rtasidan Oy o'tgan paytda Quyosh tutilishi ro'y beradi. Agar barcha uchta jism bir chiziqqa to'g'ri kelib qolsa, Oy Quyoshning nurini to'sadi va uning soyasi Yerning ma'lum bir mintaqasiga tushib turadi. Umuman olganda, Quyosh tutilishini tomosha qilishda bevosita Quyoshga qarash xavfli bo'lib, bu vaqtda maxsus ko'zoynaklardan foydalanish kerak bo'ladi.</p>
    <p>Fikr: ___________________________________________________________</p>
    <p>Dalil: _________________________________________________________</p>
    <p>Misol: ________________________________________________________</p>
        </div>
    )
}
export default Kategoriya3213;